import { CreatePromotionChallengePage } from './CreatePromotionChallengePage'
import { withCreatePromotionChallengePage } from './withCreatePromotionChallengePage'

const Connected = withCreatePromotionChallengePage(CreatePromotionChallengePage)

export { Connected as CreatePromotionChallengePage }
